import WalletStatusTab from './WalletStatusTab';

export default WalletStatusTab;
